import conditionals from './conditionals/index';
import composers from './composers/index';

const subjects = { conditionals, composers };

export default subjects;
